import React, { useState } from "react";

import * as S from "./styles";
import { MessageRight, MessageLeft } from "components/shared";
import { Cam } from "components/shared";
interface Props {
  active: boolean;
}

export const Slide9: React.FC<Props> = ({ active }) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <S.Container>
      <S.Chat>
        {active && (
          <S.ChatContent>
            <S.HeaderChat>
              <S.IconLeft />
              <S.Avatar />
              <S.Name>Mickael Meu Amor</S.Name>
            </S.HeaderChat>
            <MessageRight
              message={`Oi, amor, tudo bem?<br />Como você está?`}
              time="18:21"
              className="animate__animated animate__backInRight animate__faster"
            />
            <MessageRight
              message={`Estou morrendo de saudades<br /> de você já 😥`}
              time="18:21"
              className="animate__animated animate__backInRight animate__faster animate__delay-1s"
            />
            <MessageLeft
              message={`Tá tudo bem amor. E com você?`}
              time="18:21"
              className="animate__animated animate__backInLeft animate__faster animate__delay-3s"
            />
            <MessageRight
              message={`Estou bem amor!`}
              time="18:21"
              className="animate__animated animate__backInRight animate__faster animate__delay-4s"
            />
            <MessageLeft
              message={`Saudades, mas em breve<br />a gente vai se ver!`}
              time="18:22"
              className="animate__animated animate__backInLeft animate__faster animate__delay-5s"
            />
            <S.ButtonPhoto onClick={() => setOpen(true)}>
              <S.IconPlay />
              Foto
            </S.ButtonPhoto>
          </S.ChatContent>
        )}
      </S.Chat>
      <S.Overlay active={open}>
        <S.Modal active={open}>
          <S.PhotoWrapper>
            <S.ButtonClose onClick={() => setOpen(false)}>
              <S.IconClose />
            </S.ButtonClose>
            <Cam />
            <S.PhotoModal />
          </S.PhotoWrapper>
          <S.Credit>
            Camisa, R$ 329, e calça, R$ 359, ambas Cotton Project. Colar,
            acervo. Anéis, R$ 580 (mão direita) e R$ 600 (mão esquerda), Quo
            Joias.
          </S.Credit>
        </S.Modal>
      </S.Overlay>
      <S.Photo>
        <S.Text>
          Camisa, R$ 329, e calça, R$ 359, ambas Cotton Project. Colar, acervo.
          Anéis, R$ 580 (mão direita) e R$ 600 (mão esquerda), Quo Joias.
        </S.Text>
      </S.Photo>
    </S.Container>
  );
};
